export const DROPDOWN_TYPES = ['autocomplete', 'tag'];

export const FIELD_TYPES = [
    { value: 'autocomplete', label: 'STATIC.PAGES.GOVERNANCE.SCHEMAS.TYPE_DROPDOWN' },
    { value: 'tag', label: 'STATIC.PAGES.GOVERNANCE.SCHEMAS.TYPE_MULTI_SELECT' },
    { value: 'text', label: 'STATIC.PAGES.GOVERNANCE.SCHEMAS.TYPE_FREE_TEXT' },
    { value: 'single_asset', label: 'STATIC.PAGES.GOVERNANCE.SCHEMAS.TYPE_SINGLE_ASSET' },
];
